
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

    @Component
    export default class KeyboardInput extends Vue {
        list = [] as string[];
        checkList = [];
        input = "";  //自定义原因
        other = false;
        @Prop() private type!: number;
        created(){
            if(this.type == 1){
                this.list = ["身份证号码错误","姓名错误","身份证过期失效","上传的身份证不符合要求",
                ]
            }else{
                this.list = ["填写的统一信用代码错误","填写的单位名称错误","注册时所选单位类型错误","注册时所选单位类型有漏选或多选",'注册时“所在区域”选择错误',"上传的单位法人证书图片不清晰，无法识别",
                    "未上传授权委托书","授权委托书签字不完善","授权委托书与被授权人信息不符","被授权人身份证号码错误","被授权人姓名错误","被授权人身份证过期失效","上传的被授权人身份证不符合要求",
                ]
            }
        }
        getText(){
            let text = this.checkList.join(";");
            if(this.other){
                text = this.checkList.length>0?(text+';'+this.input) : this.input;
            }
            return text;
        }
    }
